import type { FunctionComponent, PropsWithChildren } from 'react';

export const MaskField: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <span className="fs-mask">{children}</span>;
};
